import { createFileRoute } from '@tanstack/react-router'
import SubscribePage from '#/pages/SubscribePage'
import { coursesQueryOptions } from '#/features/courses/hooks/useCourses'
import { plansQueryOptions } from '#/features/plans/hooks/usePlans'

export type SubscribeSearch = {
  course?: string
  plan?: string
  duration?: string
}

export const Route = createFileRoute('/_home/subscribe')({
  validateSearch: (search: Record<string, unknown>): SubscribeSearch => {
    return {
      course: typeof search.course === 'string' ? search.course : undefined,
      plan: typeof search.plan === 'string' ? search.plan : undefined,
      duration:
        typeof search.duration === 'string' ? search.duration : undefined,
    }
  },
  loader: async ({ context: { queryClient } }) => {
    await Promise.all([
      queryClient.ensureQueryData(coursesQueryOptions({ limit: 100 })),
      queryClient.ensureQueryData(plansQueryOptions()),
      queryClient.ensureQueryData(coursesQueryOptions({ limit: 5 })),
    ])
  },
  head: () => ({
    meta: [
      {
        title: "Enroll for Free Trial | Wa'allamah",
      },
      {
        name: 'description',
        content:
          "Book your free trial assessment class with certified Ijaza tutors at Wa'allamah Academy.",
      },
    ],
  }),
  component: SubscribePage,
})
